import React from 'react';
import PropTypes from 'prop-types';

import { withTheme } from '@material-ui/core/styles';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconReports = ({ theme, ...otherProps }) => (
  <SvgIcon {...otherProps} viewBox="0 0 127.69121 128.33511">
    <path fill={theme.palette.primary.A100} d="m30.803 0.0001c-4.8638 0-8.807 3.9627-8.807 8.8505v92.912l61.669 0.018v15.012c0 5.78 4.2031 10.94 9.9255 11.488 6.5677 0.629 12.092-4.542 12.092-11.012v-42.04-53.103-11.063c-0.001-6.1059 4.927-11.06 11.008-11.06h-85.888z" />
    <path fill={theme.palette.grey[100]} d="m30.803 0.0001c-4.8638 0-8.807 3.9627-8.807 8.8505v92.912l61.669 0.018v15.012c0 5.78 4.2031 10.94 9.9255 11.488 6.5677 0.629 12.092-4.542 12.092-11.012v-42.04-53.103-11.063c-0.001-6.1059 4.927-11.06 11.008-11.06h-85.888z" />
    <g fill={theme.palette.primary.A100} transform="translate(-.65232 -.66689)">
      <path transform="translate(106.33 .66699)" d="m11.009 0c-6.0792 0-11.009 4.9541-11.009 11.063v15.508h17.594c2.4441 0 4.4234-1.9913 4.4234-4.4451v-11.063c0.001-6.1091-4.929-11.063-11.008-11.063z" />
      <path transform="translate(.64844 102.43)" d="m94.676 26.572c-6.0791 0-11.009-4.9541-11.009-11.063v-15.488l-79.244-0.021c-2.4438 0-4.423 1.9913-4.423 4.4452v11.063c0 6.1091 4.9296 11.063 11.009 11.063h83.667z" />
      <path transform="translate(48.081,11.667)" d="m0 0h31.014v5.5h-31.014v-5.5z" />
      <path transform="translate(31.662,24.5)" d="m0 0h62.027v5.5h-62.027v-5.5z" />
      <path transform="translate(31.662,39.167)" d="m0 0h62.027v5.5h-62.027v-5.5z" />
      <path transform="translate(31.662,53.834)" d="m0 0h31.014v5.5h-31.014v-5.5z" />
      <path transform="translate(31.662,68.5)" d="m0 0h31.014v5.5h-31.014v-5.5z" />
      <path transform="translate(31.662,83.167)" d="m0 0h31.014v5.5h-31.014v-5.5z" />
    </g>
    <path fill={theme.palette.primary.A400} d="m96.937 71.626c0-12.22-9.857-22.126-22.017-22.126-12.161 0-22.018 9.9059-22.018 22.126s9.8572 22.126 22.018 22.126c12.16 0 22.018-9.9062 22.018-22.126z" />
    <path fill={theme.palette.grey[100]} d="m82.887 69.929h-5.4597v-5.4867c0.001-1.165-0.939-2.109-2.0977-2.109-1.1594 0-2.0986 0.94396-2.0986 2.109v5.4867h-5.4598c-1.1591 0-2.0986 0.944-2.0986 2.109 0 1.1653 0.93954 2.1093 2.0986 2.1093h5.4598v5.487c0 1.1648 0.93921 2.1089 2.0986 2.1089 1.159 0 2.0986-0.9441 2.0986-2.1089v-5.487h5.4597c1.1593 0 2.0986-0.9438 2.0986-2.1089 0-1.165-0.9398-2.109-2.0986-2.109z" />
  </SvgIcon>
);

IconReports.propTypes = {
  theme: PropTypes.shape({
    palette: PropTypes.shape({
      primary: PropTypes.shape({
        A100: PropTypes.string.isRequired,
        A400: PropTypes.string.isRequired,
      }).isRequired,
      grey: PropTypes.shape({
        100: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default withTheme()(IconReports);



// WEBPACK FOOTER //
// ./src/components/icons/IconReports.js